export default "__VITE_ASSET__QALO6RFR__"